import React from 'react';
import RegisterWizard from '../../components/RegisterWizard';

function Register() {
  return (
    <div className='min-h-screen bg-[#EBF4FB]'>
      <RegisterWizard />
    </div>
  );
}

export default Register;
